var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-breadcrumbs',{staticClass:"px-0",attrs:{"items":_vm.items}}),_c('v-row',{staticClass:"mt-10"},[_c('v-col',[_c('span',{staticClass:"header bold text-tcdc-green"},[_vm._v("CONSULT")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }